if (window.location.pathname === '/cart') {
  // window.location.href = '/checkout';
}

document.addEventListener("DOMContentLoaded", function () {
  const triggerElement = document.querySelector("[data-target-shop-section]"); // element you click
  const targetButton = document.querySelector(".product-card__btn");   // button to click

  if (!triggerElement || !targetButton) return;

  triggerElement.addEventListener("click", function () {
    // Click the button
    targetButton.click();

    // Check if mobile
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      // Scroll to bottom smoothly
      // window.scrollTo({
      //   top: document.body.scrollHeight,
      //   behavior: "smooth"
      // });
    }
  });
});